import {
  addPostToLibraryAction,
  changeHeadingAction,
  createEvolveBannerBottomAction,
  createEvolveMemberUseAction,
  deleteEvolveMemberUseAction,
  getEvolveOurCommunityAction,
  getEvolvePageSeoAction,
  getHeadingContentAction,
  getLibraryAction,
  updateEvolveMemberUseAction,
  updateEvolveOurCommunityAction,
  updateEvolvePageSeoAction,
} from './../actions/evolve-landing-management'
import { thunkActionLoading } from '@configs'
import { createSlice } from '@reduxjs/toolkit'
import {
  IEvolveBannerData,
  IEvolveCommunity,
  IEvolveDownloadData,
  IEvolveMemberUseItem,
  IHeadingContentRes,
  ILibraryItem,
  ISeoEvolve,
} from 'src/interfaces/evolve-landing-management'
import { IFeatureDetail } from 'src/components/evolve-landing-page-management/feature/FeatureDetailModal'
import { RootState } from '.'
import {
  getEvolveBannerBottomAction,
  getEvolveBannerTopAction,
  getEvolveMemberUseAction,
  createEvolveBannerTopAction,
  getEvolveFeatureListAction,
  getEvolveFeatureByIdAction,
  createEvolveFeatureAction,
  updateEvolveFeatureAction,
  deleteEvolveFeatureAction,
  getEvolveDownloadAction,
  createEvolveDownloadAction,
} from '../actions/evolve-landing-management'

interface IEvolveLandingManagement {
  bannerTop: IEvolveBannerData | undefined
  bannerBottom: IEvolveBannerData | undefined
  download: IEvolveDownloadData | undefined
  features: IFeatureDetail[]
  selectedFeature: IFeatureDetail | undefined
  memberUse: IEvolveMemberUseItem[] | undefined
  memberUseContent: IHeadingContentRes | undefined
  library: ILibraryItem | undefined
  evolveSeo: ISeoEvolve | undefined
  community: IEvolveCommunity | undefined
  loadings: Record<string, boolean | undefined>
}

const initialState: IEvolveLandingManagement = {
  bannerTop: undefined,
  bannerBottom: undefined,
  download: undefined,
  features: [],
  selectedFeature: undefined,
  memberUse: undefined,
  memberUseContent: undefined,
  library: undefined,
  evolveSeo: undefined,
  community: undefined,
  loadings: {},
}

const evolveLandingManagement = createSlice({
  name: 'evolveLandingManagement',
  initialState,
  reducers: {
    clearSelectedFeature: (state) => {
      state.selectedFeature = undefined
    },
    setSelectedFeature: (state, action) => {
      state.selectedFeature = action.payload
    },
    clearFeatures: (state) => {
      state.features = []
    },
  },
  extraReducers: (builder) => {
    // Banner Actions
    builder.addCase(getEvolveBannerTopAction.pending, (state) => {
      state.loadings[thunkActionLoading.GET_BANNER_TOP_LOADING] = true
    })
    builder.addCase(getEvolveBannerTopAction.rejected, (state) => {
      state.loadings[thunkActionLoading.GET_BANNER_TOP_LOADING] = false
    })
    builder.addCase(getEvolveBannerTopAction.fulfilled, (state, action) => {
      state.loadings[thunkActionLoading.GET_BANNER_TOP_LOADING] = false
      state.bannerTop = action.payload.data
    })
    //banner bottom
    builder.addCase(getEvolveBannerBottomAction.pending, (state) => {
      state.loadings[thunkActionLoading.GET_BANNER_BOTTOM_LOADING] = true
    })
    builder.addCase(getEvolveBannerBottomAction.rejected, (state, action) => {
      state.loadings[thunkActionLoading.GET_BANNER_BOTTOM_LOADING] = false
    })
    builder.addCase(getEvolveBannerBottomAction.fulfilled, (state, action) => {
      state.loadings[thunkActionLoading.GET_BANNER_BOTTOM_LOADING] = false
      state.bannerBottom = action.payload.data
    })

    builder.addCase(createEvolveBannerTopAction.pending, (state) => {
      state.loadings[thunkActionLoading.CREATE_BANNER_TOP_LOADING] = true
    })
    builder.addCase(createEvolveBannerTopAction.rejected, (state) => {
      state.loadings[thunkActionLoading.CREATE_BANNER_TOP_LOADING] = false
    })
    builder.addCase(createEvolveBannerTopAction.fulfilled, (state, action) => {
      state.loadings[thunkActionLoading.CREATE_BANNER_TOP_LOADING] = false
      state.bannerTop = action.payload.data.commonContent
    })

    builder.addCase(createEvolveBannerBottomAction.pending, (state) => {
      state.loadings[thunkActionLoading.CREATE_BANNER_BOTTOM_LOADING] = true
    })
    builder.addCase(createEvolveBannerBottomAction.rejected, (state) => {
      state.loadings[thunkActionLoading.CREATE_BANNER_BOTTOM_LOADING] = false
    })
    builder.addCase(
      createEvolveBannerBottomAction.fulfilled,
      (state, action) => {
        state.loadings[thunkActionLoading.CREATE_BANNER_BOTTOM_LOADING] = false
        state.bannerBottom = action.payload.data.commonContent
      }
    )

    // Feature Actions
    builder.addCase(getEvolveFeatureListAction.pending, (state) => {
      state.loadings[thunkActionLoading.GET_EVOLVE_FEATURE_LIST_LOADING] = true
    })
    builder.addCase(getEvolveFeatureListAction.rejected, (state, action) => {
      state.loadings[thunkActionLoading.GET_EVOLVE_FEATURE_LIST_LOADING] = false
    })
    builder.addCase(getEvolveFeatureListAction.fulfilled, (state, action) => {
      state.loadings[thunkActionLoading.GET_EVOLVE_FEATURE_LIST_LOADING] = false
      const featuresList = action.payload.data || action.payload
      state.features = Array.isArray(featuresList) ? featuresList : []
    })

    builder.addCase(getEvolveFeatureByIdAction.pending, (state) => {
      state.loadings[thunkActionLoading.GET_EVOLVE_FEATURE_BY_ID_LOADING] = true
    })
    builder.addCase(getEvolveFeatureByIdAction.rejected, (state) => {
      state.loadings[thunkActionLoading.GET_EVOLVE_FEATURE_BY_ID_LOADING] =
        false
    })
    builder.addCase(getEvolveFeatureByIdAction.fulfilled, (state, action) => {
      state.loadings[thunkActionLoading.GET_EVOLVE_FEATURE_BY_ID_LOADING] =
        false
      state.selectedFeature = action.payload.data || action.payload
    })

    builder.addCase(createEvolveFeatureAction.pending, (state) => {
      state.loadings[thunkActionLoading.CREATE_EVOLVE_FEATURE_LOADING] = true
    })
    builder.addCase(createEvolveFeatureAction.rejected, (state) => {
      state.loadings[thunkActionLoading.CREATE_EVOLVE_FEATURE_LOADING] = false
    })
    builder.addCase(createEvolveFeatureAction.fulfilled, (state, action) => {
      state.loadings[thunkActionLoading.CREATE_EVOLVE_FEATURE_LOADING] = false
      // Handle the API response structure: { evolveFeature: IFeatureDetail, message: string }
      const newFeature = action.payload.data.evolveFeature

      state.features.push(newFeature)
    })

    builder.addCase(updateEvolveFeatureAction.pending, (state) => {
      state.loadings[thunkActionLoading.UPDATE_EVOLVE_FEATURE_LOADING] = true
    })
    builder.addCase(updateEvolveFeatureAction.rejected, (state) => {
      state.loadings[thunkActionLoading.UPDATE_EVOLVE_FEATURE_LOADING] = false
    })
    builder.addCase(updateEvolveFeatureAction.fulfilled, (state, action) => {
      state.loadings[thunkActionLoading.UPDATE_EVOLVE_FEATURE_LOADING] = false

      // Extract the feature from the response
      const updatedFeature =
        action.payload.data.evolveFeature ||
        (action.payload as unknown as IFeatureDetail)

      const index = state.features.findIndex((f) => f.id === updatedFeature.id)
      if (index !== -1) {
        state.features[index] = updatedFeature
      }
      if (state.selectedFeature?.id === updatedFeature.id) {
        state.selectedFeature = updatedFeature
      }
    })

    builder.addCase(deleteEvolveFeatureAction.pending, (state) => {
      state.loadings[thunkActionLoading.DELETE_EVOLVE_FEATURE_LOADING] = true
    })
    builder.addCase(deleteEvolveFeatureAction.rejected, (state) => {
      state.loadings[thunkActionLoading.DELETE_EVOLVE_FEATURE_LOADING] = false
    })
    builder.addCase(deleteEvolveFeatureAction.fulfilled, (state, action) => {
      state.loadings[thunkActionLoading.DELETE_EVOLVE_FEATURE_LOADING] = false
      const deletedId = action.payload.id
      state.features = state.features.filter((f) => f.id !== deletedId)
      if (state.selectedFeature?.id === deletedId) {
        state.selectedFeature = undefined
      }
    })

    // Download Actions
    builder.addCase(getEvolveDownloadAction.pending, (state) => {
      state.loadings[thunkActionLoading.GET_EVOLVE_DOWNLOAD_LOADING] = true
    })
    builder.addCase(getEvolveDownloadAction.rejected, (state) => {
      state.loadings[thunkActionLoading.GET_EVOLVE_DOWNLOAD_LOADING] = false
    })
    builder.addCase(getEvolveDownloadAction.fulfilled, (state, action) => {
      state.loadings[thunkActionLoading.GET_EVOLVE_DOWNLOAD_LOADING] = false
      state.download = action.payload.data || action.payload
    })

    builder.addCase(createEvolveDownloadAction.pending, (state) => {
      state.loadings[thunkActionLoading.CREATE_EVOLVE_DOWNLOAD_LOADING] = true
    })
    builder.addCase(createEvolveDownloadAction.rejected, (state) => {
      state.loadings[thunkActionLoading.CREATE_EVOLVE_DOWNLOAD_LOADING] = false
    })
    builder.addCase(createEvolveDownloadAction.fulfilled, (state, action) => {
      state.loadings[thunkActionLoading.CREATE_EVOLVE_DOWNLOAD_LOADING] = false
      state.download = action.payload.data.commonContent
    })

    //member use
    builder.addCase(getEvolveMemberUseAction.pending, (state) => {
      state.loadings[thunkActionLoading.GET_MEMBER_USE_LOADING] = true
    })
    builder.addCase(getEvolveMemberUseAction.rejected, (state, action) => {
      state.loadings[thunkActionLoading.GET_MEMBER_USE_LOADING] = false
    })
    builder.addCase(getEvolveMemberUseAction.fulfilled, (state, action) => {
      state.loadings[thunkActionLoading.GET_MEMBER_USE_LOADING] = false
      state.memberUse = action.payload.data
    })
    builder.addCase(createEvolveMemberUseAction.pending, (state) => {
      state.loadings[thunkActionLoading.CREATE_MEMBER_USE_LOADING] = true
    })
    builder.addCase(createEvolveMemberUseAction.rejected, (state, action) => {
      state.loadings[thunkActionLoading.CREATE_MEMBER_USE_LOADING] = false
    })
    builder.addCase(createEvolveMemberUseAction.fulfilled, (state, action) => {
      state.loadings[thunkActionLoading.CREATE_MEMBER_USE_LOADING] = false
    })
    builder.addCase(updateEvolveMemberUseAction.pending, (state) => {
      state.loadings[thunkActionLoading.UPDATE_MEMBER_USE_LOADING] = true
    })
    builder.addCase(updateEvolveMemberUseAction.rejected, (state, action) => {
      state.loadings[thunkActionLoading.UPDATE_MEMBER_USE_LOADING] = false
    })
    builder.addCase(updateEvolveMemberUseAction.fulfilled, (state, action) => {
      state.loadings[thunkActionLoading.UPDATE_MEMBER_USE_LOADING] = false
      state.memberUse = action.payload.data
    })
    builder.addCase(deleteEvolveMemberUseAction.pending, (state) => {
      state.loadings[thunkActionLoading.DELETE_MEMBER_USE_LOADING] = true
    })
    builder.addCase(deleteEvolveMemberUseAction.rejected, (state, action) => {
      state.loadings[thunkActionLoading.DELETE_MEMBER_USE_LOADING] = false
    })
    builder.addCase(deleteEvolveMemberUseAction.fulfilled, (state, action) => {
      state.loadings[thunkActionLoading.DELETE_MEMBER_USE_LOADING] = false
    })
    builder.addCase(getHeadingContentAction.pending, (state) => {
      state.loadings[thunkActionLoading.GET_HEADING_CONTENT_LOADING] = true
    })
    builder.addCase(getHeadingContentAction.rejected, (state, action) => {
      state.loadings[thunkActionLoading.GET_HEADING_CONTENT_LOADING] = false
    })
    builder.addCase(getHeadingContentAction.fulfilled, (state, action) => {
      state.loadings[thunkActionLoading.GET_HEADING_CONTENT_LOADING] = false
      state.memberUseContent = action.payload.data
    })
    builder.addCase(changeHeadingAction.pending, (state) => {
      state.loadings[thunkActionLoading.CHANGE_HEADING_CONTENT_LOADING] = true
    })
    builder.addCase(changeHeadingAction.rejected, (state, action) => {
      state.loadings[thunkActionLoading.CHANGE_HEADING_CONTENT_LOADING] = false
    })
    builder.addCase(changeHeadingAction.fulfilled, (state, action) => {
      state.loadings[thunkActionLoading.CHANGE_HEADING_CONTENT_LOADING] = false
    })
    //library
    builder.addCase(getLibraryAction.pending, (state) => {
      state.loadings[thunkActionLoading.GET_LIBRARY_LOADING] = true
    })
    builder.addCase(getLibraryAction.rejected, (state, action) => {
      state.loadings[thunkActionLoading.GET_LIBRARY_LOADING] = false
    })
    builder.addCase(getLibraryAction.fulfilled, (state, action) => {
      state.loadings[thunkActionLoading.GET_LIBRARY_LOADING] = false
      state.library = action.payload.data.evolveLibrary
    })
    builder.addCase(addPostToLibraryAction.pending, (state) => {
      state.loadings[thunkActionLoading.ADD_POST_LIBRARY_LOADING] = true
    })
    builder.addCase(addPostToLibraryAction.rejected, (state, action) => {
      state.loadings[thunkActionLoading.ADD_POST_LIBRARY_LOADING] = false
    })
    builder.addCase(addPostToLibraryAction.fulfilled, (state, action) => {
      state.loadings[thunkActionLoading.ADD_POST_LIBRARY_LOADING] = false
      state.library = action.payload.data.evolveLibrary
    })
    //seo
    builder.addCase(getEvolvePageSeoAction.pending, (state) => {
      state.loadings[thunkActionLoading.GET_EVOLVE_SEO_CONFIG_LOADING] = true
    })
    builder.addCase(getEvolvePageSeoAction.rejected, (state, action) => {
      state.loadings[thunkActionLoading.GET_EVOLVE_SEO_CONFIG_LOADING] = false
    })
    builder.addCase(getEvolvePageSeoAction.fulfilled, (state, action) => {
      state.loadings[thunkActionLoading.GET_EVOLVE_SEO_CONFIG_LOADING] = false
      state.evolveSeo = action.payload.data
    })
    builder.addCase(updateEvolvePageSeoAction.pending, (state) => {
      state.loadings[thunkActionLoading.UPDATE_EVOLVE_SEO_CONFIG_LOADING] = true
    })
    builder.addCase(updateEvolvePageSeoAction.rejected, (state, action) => {
      state.loadings[thunkActionLoading.UPDATE_EVOLVE_SEO_CONFIG_LOADING] =
        false
    })
    builder.addCase(updateEvolvePageSeoAction.fulfilled, (state, action) => {
      state.loadings[thunkActionLoading.UPDATE_EVOLVE_SEO_CONFIG_LOADING] =
        false
      state.evolveSeo = action.payload.data.commonContent
    })
    // our community
    builder.addCase(getEvolveOurCommunityAction.pending, (state) => {
      state.loadings[thunkActionLoading.GET_EVOLVE_OUR_COMMUNITY_LOADING] = true
    })
    builder.addCase(getEvolveOurCommunityAction.rejected, (state, action) => {
      state.loadings[thunkActionLoading.GET_EVOLVE_OUR_COMMUNITY_LOADING] =
        false
    })
    builder.addCase(getEvolveOurCommunityAction.fulfilled, (state, action) => {
      state.loadings[thunkActionLoading.GET_EVOLVE_OUR_COMMUNITY_LOADING] =
        false
      state.community = action.payload.data
    })
    builder.addCase(updateEvolveOurCommunityAction.pending, (state) => {
      state.loadings[thunkActionLoading.UPDATE_EVOLVE_OUR_COMMUNITY_LOADING] =
        true
    })
    builder.addCase(
      updateEvolveOurCommunityAction.rejected,
      (state, action) => {
        state.loadings[thunkActionLoading.UPDATE_EVOLVE_OUR_COMMUNITY_LOADING] =
          false
      }
    )
    builder.addCase(
      updateEvolveOurCommunityAction.fulfilled,
      (state, action) => {
        state.loadings[thunkActionLoading.UPDATE_EVOLVE_OUR_COMMUNITY_LOADING] =
          false
        state.community = action.payload.data.commonContent
      }
    )
  },
})

export const evolveLandingActions = {
  ...evolveLandingManagement.actions,
}

// Selectors
export const selectEvolveLandingLoading = (state: RootState, name: string) =>
  state.evolveLanding.loadings[`${name}`]

export const selectEvolveBannerTop = (state: RootState) =>
  state.evolveLanding.bannerTop

export const selectEvolveFeatures = (state: RootState) =>
  state.evolveLanding.features

export const selectEvolveSelectedFeature = (state: RootState) =>
  state.evolveLanding.selectedFeature

export const selectEvolveFeatureListLoading = (state: RootState) =>
  state.evolveLanding.loadings[
    thunkActionLoading.GET_EVOLVE_FEATURE_LIST_LOADING
  ]

export const selectEvolveFeatureCreateLoading = (state: RootState) =>
  state.evolveLanding.loadings[thunkActionLoading.CREATE_EVOLVE_FEATURE_LOADING]

export const selectEvolveFeatureUpdateLoading = (state: RootState) =>
  state.evolveLanding.loadings[thunkActionLoading.UPDATE_EVOLVE_FEATURE_LOADING]

export const selectEvolveFeatureDeleteLoading = (state: RootState) =>
  state.evolveLanding.loadings[thunkActionLoading.DELETE_EVOLVE_FEATURE_LOADING]

export const selectEvolveFeatureByIdLoading = (state: RootState) =>
  state.evolveLanding.loadings[
    thunkActionLoading.GET_EVOLVE_FEATURE_BY_ID_LOADING
  ]

// Download selectors
export const selectEvolveDownload = (state: RootState) =>
  state.evolveLanding.download
export const selectEvolveDownloadLoading = (state: RootState) =>
  state.evolveLanding.loadings[thunkActionLoading.GET_EVOLVE_DOWNLOAD_LOADING]
export const selectEvolveDownloadCreateLoading = (state: RootState) =>
  state.evolveLanding.loadings[
    thunkActionLoading.CREATE_EVOLVE_DOWNLOAD_LOADING
  ]

export default evolveLandingManagement.reducer
